import Monkey from '../../../assets/monkey.png'

import FoldersAll from '../../../assets/settings/FoldersAll.png'
import FoldersNew from '../../../assets/settings/FoldersNew.png'
import DiscussionGroups from '../../../assets/tgs/settings/DiscussionGroupsDucks.tgs?url'
import Lock from '../../../assets/lock.png'
import Congratulations from '../../../assets/settings/Congratulations.png'
import Experimental from '../../../assets/tgs/settings/Experimental.tgs?url'

import CameraFlip from '../../../assets/tgs/calls/CameraFlip.tgs?url'
import HandFilled from '../../../assets/tgs/calls/HandFilled.tgs?url'
import HandOutline from '../../../assets/tgs/calls/HandOutline.tgs?url'
import Speaker from '../../../assets/tgs/calls/Speaker.tgs?url'
import VoiceAllowTalk from '../../../assets/tgs/calls/VoiceAllowTalk.tgs?url'
import VoiceMini from '../../../assets/tgs/calls/VoiceMini.tgs?url'
import VoiceMuted from '../../../assets/tgs/calls/VoiceMuted.tgs?url'
import VoiceOutlined from '../../../assets/tgs/calls/VoiceOutlined.tgs?url'

import JoinRequest from '../../../assets/invites/Requests.png'
import Invite from '../../../assets/invites/Invite.png'

import QrPlane from '../../../assets/tgs/auth/QrPlane.tgs?url'

export const LOCAL_TGS_URLS = {
  MonkeyIdle: Monkey,
  MonkeyTracking: Monkey,
  MonkeyClose: Monkey,
  MonkeyPeek: Monkey,
  FoldersAll,
  FoldersNew,
  DiscussionGroups,
  Lock,
  CameraFlip,
  HandFilled,
  HandOutline,
  Speaker,
  VoiceAllowTalk,
  VoiceMini,
  VoiceMuted,
  VoiceOutlined,
  JoinRequest,
  Invite,
  QrPlane,
  Congratulations,
  Experimental,
}
